// import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


export default function LanuageBtn() {
    // In your component:
    const navigate = useNavigate();
    const { lang } = useParams();
    const location = useLocation();
    const { i18n } = useTranslation();

    const changeLanguage = (newLang) => {
        if (lang === newLang) return;

        // Build new path by replacing current language with new language
        const pathWithoutLang = location.pathname.replace(`/${lang}`, '');
        const newPath = `/${newLang}${pathWithoutLang}`;

        // Navigate to new URL
        navigate(newPath + location.search + location.hash);
    };

    return (
        <>
            <FontAwesomeIcon type='button'
                icon={faGlobe}
                // icon={faLanguage}
                className='btn-masar btn-med-gray text-white px-2'
                id="langDropdown" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false" />

            <ul className={`dropdown-menu dropdown-menu-end text-end border-white`}
                aria-labelledby="langDropdown">
                <>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={(e) => {
                                e.preventDefault();
                                i18n.changeLanguage('ar')
                                changeLanguage('ar');
                                window.location.reload();
                            }}
                            to="#"
                        >عربي</Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={(e) => {
                                e.preventDefault();
                                i18n.changeLanguage('en')
                                changeLanguage('en');
                                window.location.reload();

                            }}
                            to="#"
                        >English</Link>
                    </li>
                </>

            </ul>
        </>

    )
}

